import { useEffect, useState } from "react";
import FsLightbox from "fslightbox-react";
import AOS from "aos";
import ArmoImage from "./assets/arman_image.JPG";
import VaroImage from "./assets/varo_image.JPG";
import GalleryImage1 from "./assets/gallery1.jpg";
import GalleryImage2 from "./assets/gallery2.jpg";
import GalleryImage3 from "./assets/gallery3.jpg";
import GalleryImage4 from "./assets/gallery4.jpg";
import GalleryImage5 from "./assets/gallery5.jpg";
import GalleryImage6 from "./assets/gallery6.jpg";

// Services images
import FadeImage from "./assets/services/fade.jpg";
import BeardImage from "./assets/services/beard.jpg";
import BeardImageExpensive from "./assets/services/beard.PNG";
import CircularText from "./CircularText";
import RegularHaircut from "./assets/services/regular.jpg";
import FaceCare from "./assets/services/face_care.jpg";
import "aos/dist/aos.css";
import "./App.css";

const services = [
  {
    name: "Fade",
    price: "4000 դր․",
    img: FadeImage,
    duration: "40 րոպե",
    description:
      "A timeless cut tailored to your style, finished with precision.",
  },
  {
    name: "Կլասիկ կտրվածք և մորուքի ձևավորում",
    price: "6000 դր․",
    img: BeardImage,
    duration: "50 րոպե",
    description:
      "Մասնագիտական սափրում, մորուքի ձևավորում և մազերի կտրում՝ կոկիկ ու խնամված տեսքի համար",
  },
  {
    name: "Fade և մորուքի ձևավորում",
    price: "7000 դր․",
    img: BeardImageExpensive,
    duration: "50 րոպե",
    description:
      "Ձեր կերպարի կատարյալ թարմացումը՝ մազերի և մորուքի պրոֆեսիոնալ խնամքով",
  },
  {
    name: "Կլասիկ կտրվածք",
    price: "3000 դրամ",
    img: RegularHaircut,
    duration: "30 րոպե",
    description: "Մասնագիտական մազերի կտրում՝ կոկիկ և խնամված տեսքի համար",
  },
  {
    name: "Դեմքի խնամք",
    price: "4000 դր․",
    img: FaceCare,
    duration: "30 րոպե",
    description: "Մաշկի խնամք՝ մաքուր և առողջ դեմքի համար",
  },
];

const team = [
  {
    name: "Arman Haroyan",
    role: "Master Barber",
    img: ArmoImage,
    bio: "Ավելի քան 10 տարվա փորձ։ Ունի խորացված գիտելիքներ և հմտություններ ոլորտում",
  },
  {
    name: "Varo Vardazaryan",
    role: "Fade Specialist",
    img: VaroImage,
    bio: "Fade and beard expert. Loves making clients look sharp.",
  },
];

const gallery = [
  GalleryImage1,
  GalleryImage2,
  GalleryImage3,
  GalleryImage4,
  GalleryImage5,
  GalleryImage6,
];

const testimonials = [
  {
    name: "Narek",
    text: "Best barbershop in Yerevan! The team is super friendly and talented.",
  },
  {
    name: "Anna",
    text: "My son loves getting his hair cut here. Always a great experience!",
  },
  {
    name: "Vahan",
    text: "Professional service and a relaxing atmosphere. Highly recommend!",
  },
];

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1,
  });

  const openLightboxOnSlide = (idx) => {
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: idx + 1,
    });
  };

  return (
    <div className="font-sans bg-gradient-to-br from-blue-900 via-gray-900 to-blue-700 min-h-screen text-white">
      {/* Hero Section */}
      <section
        className="flex flex-col items-center justify-around h-screen text-center px-4"
        style={{ background: "rgba(0,0,0,0.7)" }}
      >
        <div className="w-full flex justify-center mt-8 md:mt-0">
          <CircularText
            text="Haroyan Barbershop "
            onHover="speedUp"
            spinDuration={60}
            className="w-[200px] h-[200px] md:w-[400px] md:h-[400px] custom-class"
          />
        </div>
        <p
          className="text-xl md:text-2xl mb-8 max-w-xl mx-auto"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          Որտեղ ոճը հանդիպում է ավանդույթին։ Փորձեք լավագույն սանրվածքները,
          սափրումները և խնամքը քաղաքում
        </p>
        <a
          href="#services"
          className="bg-gradient-to-r from-yellow-400 to-yellow-600 text-gray-900 font-bold px-8 py-3 rounded-full shadow-lg hover:scale-105 transition-transform"
          data-aos="zoom-in"
          data-aos-delay="400"
        >
          Տեսնել մեր ծառայությունները
        </a>
      </section>

      {/* About Us Section */}
      <section className="py-20 px-4 max-w-4xl mx-auto" data-aos="fade-up">
        <h2 className="text-4xl font-bold text-center mb-6">Մեր Մասին</h2>
        <p className="text-lg text-center text-gray-300">
          Հիմնադրվել է 2017 թվականին, Հարոյան Վարսավիրանոցը նվիրված է բարձրակարգ
          խնամքի ծառայություններ մատուցելուն՝ ջերմ, ոճային միջավայրում։ Մեր
          փորձառու վարսավիրների թիմը համադրում է ավանդույթն ու նորագույն
          միտումները՝ ապահովելու համար, որ յուրաքանչյուր հաճախորդ հեռանա գեղեցիկ
          և ինքնավստահ։
        </p>
      </section>

      {/* Team Section */}
      <section className="py-20 px-4 max-w-6xl mx-auto" data-aos="fade-up">
        <h2 className="text-4xl font-bold text-center mb-12">Մեր Թիմը</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {team.map((member, idx) => (
            <div
              key={member.name}
              className="bg-gray-800 rounded-3xl shadow-xl flex flex-col items-center p-8"
              data-aos="fade-up"
              data-aos-delay={idx * 100}
            >
              <img
                src={member.img}
                alt={member.name}
                className="w-32 h-32 rounded-full object-cover mb-4 border-4 border-yellow-400"
              />
              <h3 className="text-2xl font-semibold mb-1">{member.name}</h3>
              <span className="text-yellow-400 font-bold mb-2">
                {member.role === "Master Barber"
                  ? "Վարպետ Վարսավիր"
                  : member.role === "Fade Specialist"
                  ? "Ֆեյդի Մասնագետ"
                  : member.role}
              </span>
              <p className="text-gray-300 text-center">
                {member.bio ===
                "15+ years of experience. Specializes in classic and modern styles."
                  ? "15+ տարվա փորձ։ Մասնագիտական է դասական և ժամանակակից ոճերում։"
                  : member.bio ===
                    "Fade and beard expert. Loves making clients look sharp."
                  ? "Ֆեյդի և մորուքի մասնագետ։ Սիրում է հաճախորդներին դարձնել կոկիկ և ոճային։"
                  : member.bio}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 px-4 max-w-6xl mx-auto">
        <h2 className="text-4xl font-bold text-center mb-12" data-aos="fade-up">
          Մեր Ծառայությունները
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 justify-items-center">
          {services.map((service, idx) => (
            <div
              key={service.name}
              className="service-card bg-gray-800 rounded-3xl shadow-xl overflow-hidden w-full md:w-[420px]"
              data-aos="fade-up"
              data-aos-delay={idx * 100}
            >
              <img
                src={service.img}
                alt={service.name}
                className="w-full h-64 object-cover"
              />
              <div className="p-6 flex flex-col items-center">
                <h3 className="text-2xl font-semibold mb-2">
                  {service.name === "Classic Haircut"
                    ? "Դասական Սանրվածք"
                    : service.name === "Beard Trim"
                    ? "Մորուքի Կտրում"
                    : service.name === "Hot Towel Shave"
                    ? "Տաք Սրբիչով Սափրում"
                    : service.name === "Kids Cut"
                    ? "Մանկական Սանրվածք"
                    : service.name === "Fade & Style"
                    ? "Ֆեյդ և Ոճավորում"
                    : service.name === "Royal Treatment"
                    ? "Թագավորական Խնամք"
                    : service.name === "Hair Wash"
                    ? "Մազերի Լվացում"
                    : service.name === "Grey Blending"
                    ? "Մոխրագույնի Խառնուրդ"
                    : service.name}
                </h3>
                <span className="text-yellow-400 text-xl font-bold mb-2">
                  {service.price}
                </span>
                <span className="text-gray-300 text-sm mb-2">
                  {service.duration}
                </span>
                <p className="text-center text-gray-400 text-sm mb-2">
                  {service.description ===
                  "A timeless cut tailored to your style, finished with precision."
                    ? "Ժամանակակից սանրվածք՝ հարմարեցված ձեր ոճին, ավարտված ճշգրտությամբ։"
                    : service.description ===
                      "Expert shaping and trimming for a sharp, clean look."
                    ? "Մասնագիտական ձևավորում և կտրում՝ կոկիկ տեսքի համար։"
                    : service.description ===
                      "Relaxing hot towel shave with premium products."
                    ? "Հանգստացնող տաք սրբիչով սափրում՝ բարձրորակ միջոցներով։"
                    : service.description ===
                      "Fun and friendly cuts for the little ones."
                    ? "Զվարճալի և բարեկամական սանրվածքներ փոքրիկների համար։"
                    : service.description ===
                      "Modern fades with a stylish finish."
                    ? "Ժամանակակից ֆեյդեր՝ ոճային ավարտով։"
                    : service.description ===
                      "Full service: haircut, beard, hot towel, and head massage."
                    ? "Լիարժեք ծառայություն՝ սանրվածք, մորուք, տաք սրբիչ և գլխի մերսում։"
                    : service.description ===
                      "Refreshing wash with scalp massage."
                    ? "Թարմացնող լվացում՝ գլխի մերսումով։"
                    : service.description ===
                      "Subtle color blending for a natural, youthful look."
                    ? "Թեթև գունային խառնուրդ՝ բնական և երիտասարդ տեսքի համար։"
                    : service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-20 px-4 max-w-6xl mx-auto" data-aos="fade-up">
        <h2 className="text-4xl font-bold text-center mb-12">Պատկերասրահ</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
          {gallery.map((img, idx) => (
            <img
              key={idx}
              src={img}
              alt="Վարսավիրանոցի աշխատանք"
              className="rounded-2xl shadow-lg object-cover w-full h-56 cursor-pointer"
              data-aos="zoom-in"
              data-aos-delay={idx * 100}
              onClick={() => openLightboxOnSlide(idx)}
            />
          ))}
        </div>
      </section>

      {/* FsLightbox Modal */}
      <FsLightbox
        toggler={lightboxController.toggler}
        sources={gallery}
        slide={lightboxController.slide}
      />

      {/* Testimonials Section */}
      <section className="py-20 px-4 max-w-4xl mx-auto" data-aos="fade-up">
        <h2 className="text-4xl font-bold text-center mb-12">Կարծիքներ</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((t, idx) => (
            <div
              key={t.name}
              className="bg-gray-800 rounded-2xl shadow-lg p-8 flex flex-col items-center"
              data-aos="fade-up"
              data-aos-delay={idx * 100}
            >
              <svg
                className="w-8 h-8 text-yellow-400 mb-4"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M18.364 17.364A9 9 0 112.636 1.636a9 9 0 0115.728 15.728zM7 7a2 2 0 100 4 2 2 0 000-4zm6 0a2 2 0 100 4 2 2 0 000-4z" />
              </svg>
              <p className="text-gray-300 text-center mb-4">
                "
                {t.text ===
                "Best barbershop in Yerevan! The team is super friendly and talented."
                  ? "Լավագույն վարսավիրանոցը Երևանում։ Թիմը շատ բարեկամական և տաղանդավոր է։"
                  : t.text ===
                    "My son loves getting his hair cut here. Always a great experience!"
                  ? "Իմ որդին սիրում է այստեղ սանրվածք ստանալ։ Միշտ հրաշալի փորձ է։"
                  : t.text ===
                    "Professional service and a relaxing atmosphere. Highly recommend!"
                  ? "Պրոֆեսիոնալ սպասարկում և հանգիստ մթնոլորտ։ Խորհուրդ եմ տալիս։"
                  : t.text}
                "
              </p>
              <span className="text-yellow-400 font-bold">- {t.name}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Address/Contact Section */}
      <section
        className="py-20 px-4 bg-gray-900/80 flex flex-col items-center"
        data-aos="fade-up"
      >
        <h2 className="text-3xl font-bold mb-6">Այցելեք մեզ</h2>
        <p className="text-xl mb-2">Վաղարշ Վաղարշյան 18, Երևան, Հայաստան</p>
        <p className="mb-2">Բաց է՝ Երկուշաբթի-Կիրակի 10:00 - 21:00</p>
        <p className="mb-6">
          Հեռախոս՝
          <a
            href="tel:+37412345678"
            className="text-yellow-400 hover:underline"
          >
            +374 98 888 652
          </a>
        </p>
        <iframe
          title="Վարսավիրանոցի տեղադրությունը"
          src="https://www.openstreetmap.org/export/embed.html?bbox=44.499,40.202,44.509,40.212&layer=mapnik&marker=40.207,44.504"
          className="w-full max-w-xl h-64 rounded-xl border-4 border-yellow-400 shadow-lg"
          loading="lazy"
        ></iframe>
      </section>

      {/* Footer */}
      <footer className="py-6 text-center text-gray-400 text-sm bg-gray-900/90">
        &copy; {new Date().getFullYear()} Հարոյան Վարսավիրանոց։ Բոլոր
        իրավունքները պաշտպանված են։
      </footer>
    </div>
  );
}

export default App;
